export enum UserPermissions {
  ASSIGNMENT_PUBLISHED = 'entrega-publicada',
  ASSIGNMENT_AVAILABLE = 'assignment-disponivel',
  DEVELOPMENT = 'desenvolvimento',
  COURSE_SET = 'curso-selecionado',
  DISCIPLINE_SET = 'disciplina-selecionada',
  MULTIPLE_COURSES = 'multiplos-cursos',
}
